import _JSON$stringify from "/app/node_modules/babel-runtime/core-js/json/stringify";
import _regeneratorRuntime from "/app/node_modules/babel-runtime/regenerator";
import _asyncToGenerator from "/app/node_modules/babel-runtime/helpers/asyncToGenerator";
import _classCallCheck from "/app/node_modules/babel-runtime/helpers/classCallCheck";
import _createClass from "/app/node_modules/babel-runtime/helpers/createClass";
export var AffiliationApi = function () {
  function AffiliationApi(axios) {
    _classCallCheck(this, AffiliationApi);

    this.axios = axios;
  }

  _createClass(AffiliationApi, [{
    key: "saveAffiliationInProcess",
    value: function saveAffiliationInProcess(data) {
      return this.axios.$post("/affiliation/affiliation/add-AffiliationProccess", data);
    }
  }, {
    key: "getLogsType",
    value: function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(data) {
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return this.axios.$post("/affiliation/affiliation/get-logs-type", data);

              case 2:
                return _context.abrupt("return", _context.sent);

              case 3:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function getLogsType(_x) {
        return _ref.apply(this, arguments);
      }

      return getLogsType;
    }()
  }, {
    key: "saveAffiliationWorked",
    value: function saveAffiliationWorked(data) {
      return this.axios.$post("/affiliation/affiliation/add-AffiliationWorked", data);
    }
  }, {
    key: "saveAffiliationPendingCrm",
    value: function saveAffiliationPendingCrm(data) {
      return this.axios.$post("/affiliation/affiliation/add-AffiliationPendingCrm", data);
    }
  }, {
    key: "editAffiliationProcess",
    value: function editAffiliationProcess(data) {
      return this.axios.$post("/affiliation/affiliation/edit-AffiliationProcess", data);
    }
  }, {
    key: "deleteAffiliation",
    value: function deleteAffiliation(data) {
      return this.axios.$delete("/affiliation/affiliation");
    }
  }, {
    key: "findAffiliationWorked",
    value: function findAffiliationWorked(data) {
      return this.axios.$post("/affiliation/affiliation/find-AffiliationWorked", data);
    }
  }, {
    key: "findAffiliationWorkedPendingCrm",
    value: function findAffiliationWorkedPendingCrm(data) {
      return this.axios.$post("/affiliation/affiliation/find-AffiliationWorked-Pending-Crm", data);
    }
  }, {
    key: "findAffiliationProcess",
    value: function findAffiliationProcess(data) {
      return this.axios.$post("/affiliation/affiliation/find-AffiliationProcess", data);
    }
  }, {
    key: "findAffiliationProcessForTable",
    value: function findAffiliationProcessForTable(data) {
      return this.axios.$post("/affiliation/affiliation/find-AffiliationProcess-for-table", data);
    }

    //STEPS ------------

  }, {
    key: "saveProductChoice",
    value: function saveProductChoice(data) {
      return this.axios.$post("/affiliation/steps/save-Steps-ProductChoise", data);
    }
  }, {
    key: "saveRucData",
    value: function saveRucData(data) {
      return this.axios.$post("/affiliation/steps/save-Steps-RucValidations", data);
    }
  }, {
    key: "saveLegalRepresentativeData",
    value: function saveLegalRepresentativeData(data) {
      return this.axios.$post("/affiliation/steps/save-Steps-LegalRepresentative", data);
    }
  }, {
    key: "saveCommerceData",
    value: function saveCommerceData(data) {
      return this.axios.$post("/affiliation/steps/save-Steps-CommerceData", data);
    }
  }, {
    key: "saveAddress",
    value: function saveAddress(data) {
      return this.axios.$post("/affiliation/steps/save-StepsAddress", data);
    }
  }, {
    key: "saveBusinessSchedule",
    value: function saveBusinessSchedule(data) {
      return this.axios.$post("/affiliation/steps/save-Steps-BusinessSchedule", data);
    }
  }, {
    key: "saveInstallationSchedule",
    value: function saveInstallationSchedule(data) {
      return this.axios.$post("/affiliation/steps/save-Steps-InstallationSchedule", data);
    }
  }, {
    key: "saveBankAccountData",
    value: function saveBankAccountData(data) {
      return this.axios.$post("/affiliation/steps/save-Steps-BankAccountData", data);
    }
  }, {
    key: "saveMembershipRequirement",
    value: function saveMembershipRequirement(data) {
      return this.axios.post("/affiliation/steps/save-Steps-MemberShipRequirement-Details", data);
    }
  }, {
    key: "saveOsvType",
    value: function saveOsvType(data) {
      return this.axios.$post("/affiliation/steps/save-Steps-OsvType", data);
    }
  }, {
    key: "saveAffiliationSummary",
    value: function saveAffiliationSummary(data) {
      return this.axios.$post("/affiliation/steps/save-Steps-AffiliationSummary", data);
    }
  }, {
    key: "deleteFileFromS3",
    value: function deleteFileFromS3(key) {
      return this.axios.$post("/aws/delete-file", { key: key });
    }
  }, {
    key: "saveVirtualCommerceData",
    value: function saveVirtualCommerceData(data) {
      return this.axios.$post("/affiliation/steps/save-Steps-VirtualCommerceData", data);
    }
  }, {
    key: "saveStepsAdministrativePlatform",
    value: function saveStepsAdministrativePlatform(data) {
      return this.axios.$post("/affiliation/steps/save-Steps-AdministrativePlatform", data);
    }

    // END -------------

    //SAP ----------------

  }, {
    key: "validateRUC",
    value: function validateRUC(data) {
      return this.axios.$post("/affiliation/sap/validate-ruc", data);
    }
  }, {
    key: "getComision",
    value: function getComision(data) {
      return this.axios.$post("/affiliation/sap/obtener-comisiones", data);
    }
  }, {
    key: "createLogComision",
    value: function createLogComision(data) {
      console.log("data en affiliationApi> ", data);
      return this.axios.$post("/affiliation/affiliation/create-log-comission", data);
    }
  }, {
    key: "consultCliente",
    value: function consultCliente(data) {
      return this.axios.$post("/affiliation/sap/consultar-cliente", data);
    }
  }, {
    key: "getListCommerce",
    value: function getListCommerce(ruc) {
      return this.axios.$get("/affiliation/sap/list-commerce/" + ruc);
    }
  }, {
    key: "validateBankAccountNumber",
    value: function validateBankAccountNumber(data) {
      return this.axios.$post("/affiliation/sap/validate-bank-account-number", data).then(function (_ref2) {
        var result = _ref2.result;
        return result;
      });
    }
  }, {
    key: "preliminaryCheck",
    value: function preliminaryCheck(data) {
      return this.axios.$post("/affiliation/sap/preliminary-check", data);
    }
  }, {
    key: "commercialTariff",
    value: function commercialTariff(data) {
      // console.log("Api de comercial tariff");
      return this.axios.$post("/affiliation/sap/comercial-tariff", data);
    }
  }, {
    key: "affiliate",
    value: function affiliate(data, captchaCode, resend) {
      return this.axios.$post("/affiliation/sap/affiliate", data);
    }
  }, {
    key: "affiliateVirtual",
    value: function affiliateVirtual(data, captchaCode) {
      return this.axios.$post("/affiliation/sap/affiliate-virtual", data);
    }
  }, {
    key: "attachImages",
    value: function attachImages(codeComerce, idTransaction, files, filesS3) {
      return this.axios.$post("/affiliation/sap/attach-images", {
        codeComerce: codeComerce,
        idTransaction: idTransaction,
        filesS3: filesS3
      });
    }
  }, {
    key: "addCommerceCodeFile",
    value: function addCommerceCodeFile(idTransaction, codeComerce, isMultiAdress, commerceCodes) {
      return this.axios.$post("/affiliation/sap/add-commerceCode-file", {
        idTransaction: idTransaction,
        codeComerce: codeComerce,
        isMultiAdress: isMultiAdress,
        commerceCodes: commerceCodes
      });
    }
  }, {
    key: "validateCrmClient",
    value: function validateCrmClient(ruc) {
      return this.axios.$post("/affiliation/sap/validate-crm-client", { ruc: ruc });
    }

    //Paso 2 - Endpoint

  }, {
    key: "validateCrmContact",
    value: function validateCrmContact(data) {
      return this.axios.$post("/affiliation/sap/validate-crm-contact", data);
    }
  }, {
    key: "validateCrmOpportunity",
    value: function validateCrmOpportunity(data) {
      return this.axios.$post("/affiliation/sap/validate-crm-opportunity", data);
    }
  }, {
    key: "getCommercialTariff",
    value: function getCommercialTariff(data) {
      return this.axios.$post("/affiliation/sap/get-comercial-tariff", data);
    }
  }, {
    key: "validateAccount",
    value: function validateAccount(data) {
      return this.axios.$post("/affiliation/sap/validate-account", data);
    }
  }, {
    key: "generateCommerceCode",
    value: function () {
      var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(data) {
        var ruc, res;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                ruc = data.cliente ? data.cliente.ruc : '';

                console.log("Request de generacion del ruc  -- " + ruc, _JSON$stringify(data));
                _context2.prev = 2;
                _context2.next = 5;
                return this.axios.$post("/affiliation/sap/generate-commerce-code", data);

              case 5:
                res = _context2.sent;

                console.log("Viendo la respuesta en la llamada al API:  -- " + ruc, _JSON$stringify(res));
                return _context2.abrupt("return", res);

              case 10:
                _context2.prev = 10;
                _context2.t0 = _context2["catch"](2);

                console.log("Viendo el error del endpoint:  -- " + ruc, _context2.t0);
                console.log("Viendo el error del endpoint: -- " + ruc + " ", _context2.t0.message);

              case 14:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this, [[2, 10]]);
      }));

      function generateCommerceCode(_x2) {
        return _ref3.apply(this, arguments);
      }

      return generateCommerceCode;
    }()
  }, {
    key: "consultMcci",
    value: function consultMcci(data) {
      return this.axios.$post("/affiliation/sap/consult-mcci", data);
    }
  }, {
    key: "consultChannel",
    value: function consultChannel() {
      return this.axios.$get("/affiliation/sap/consult-channel");
    }
  }, {
    key: "consultSubChannel",
    value: function consultSubChannel(channelId) {
      return this.axios.$get("/affiliation/sap/consult-subchannel/" + channelId);
    }
  }, {
    key: "consultGroupChannel",
    value: function consultGroupChannel(subChannelId) {
      return this.axios.$get("/affiliation/sap/consult-group-channel/" + subChannelId);
    }

    //END --------

  }, {
    key: "verifiedPhone1",
    value: function verifiedPhone1(data) {
      return this.axios.$post("/affiliation/contactability/validation-first", data);
    }
  }, {
    key: "verifiedPhone2",
    value: function verifiedPhone2(data) {
      return this.axios.$post("/affiliation/contactability/validation-second", data);
    }
  }, {
    key: "downloadCeAfiliationRequest",
    value: function downloadCeAfiliationRequest(data) {
      return this.axios.$downloadFile("/download-ce-format", data);
    }
  }, {
    key: "downloadPosAfiliationRequest",
    value: function downloadPosAfiliationRequest(data) {
      return this.axios.$downloadFile("/download-pos-format", data);
    }
  }, {
    key: "existsAffiliationProcess",
    value: function existsAffiliationProcess(ruc) {
      return this.axios.$get("/affiliation/affiliation/exists-AffiliationProcess/" + ruc);
    }
  }, {
    key: "existsAffiliationConcreted",
    value: function existsAffiliationConcreted(ruc) {
      return this.axios.$get("/affiliation/affiliation/exists-AffiliationConcreted/" + ruc);
    }
  }]);

  return AffiliationApi;
}();


//////////////////
// WEBPACK FOOTER
// ./src/api/affiliation.js
// module id = ./src/api/affiliation.js
// module chunks = 34